/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_ResetInputs */



/**
* | output |
* | --- |
* | "Reset to defaults" |
*
* @param {Audio_Embed_Export_ResetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_reset = /** @type {((inputs?: Audio_Embed_Export_ResetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_ResetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réinitialiser les paramètres par défaut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auf Standardeinstellungen zurücksetzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ripristina le impostazioni predefinite")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сбросить до значений по умолчанию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restablecer valores predeterminados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("恢复默认设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("初期設定に戻す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डिफ़ॉल्ट पर पुनः सेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Restaurar padrões de fábrica")
	return /** @type {LocalizedString} */ ("Reset to defaults")
});